// WIP-Cockpit: Bereiche statt 21 Reiter in zwei Zeilen (Uli 12.10.2026: „Das ist ja jetzt alles gar
// nicht mehr Marketing … damit man sich da besser zurechtfindet." Name „WIP-Cockpit", Einteilung freigegeben).
//
// Die Reiter selbst bleiben unverändert (gleiche data-tab, gleiche Panels, gleiche Init-Funktionen).
// Hier wird nur umsortiert: oben eine Zeile mit den Bereichen, darunter die Reiter des gewählten
// Bereichs. Bewusst zur Laufzeit statt in app.html: app.html liest der Server nur beim Start ein,
// so wirkt die Änderung ohne Neustart (siehe feedback_pm2_restart_ecosystem).

export const COCKPIT_TITEL = "WIP-Cockpit";

const BEREICHE: Array<{ key: string; label: string; tabs: string[] }> = [
  { key: "planung", label: "📋 Planung", tabs: ["masterplan", "baustellen", "pflichten", "pflichtenheft-fasz"] },
  { key: "inhalte", label: "✍️ Inhalte & Social", tabs: ["blog", "radar", "social", "inbox", "followers"] },
  { key: "seo", label: "🔍 SEO & Analyse", tabs: ["seo", "opportunities", "analytics", "performance", "wettbewerb"] },
  { key: "werbung", label: "💶 Werbung & Umsatz", tabs: ["ads", "meta", "bilanz", "awin", "partner"] },
  { key: "verwaltung", label: "🗂 Verwaltung", tabs: ["dateien", "apicosts", "settings"] },
];
const FALLBACK = "verwaltung"; // neuer Reiter ohne Zuordnung verschwindet nicht, sondern landet hier

/** localStorage kann im privaten Fenster werfen — die Navigation muss trotzdem gehen. */
const merke = (k: string, v: string): void => { try { localStorage.setItem(k, v); } catch { /* egal */ } };
const lies = (k: string): string | null => { try { return localStorage.getItem(k); } catch { return null; } };

export function baueCockpitNavigation(m: HTMLElement): void {
  const titel = m.querySelector("h2");
  if (titel) titel.textContent = COCKPIT_TITEL;
  const tabsEl = m.querySelector(".tabs") as HTMLElement | null;
  if (!tabsEl || tabsEl.dataset.cockpit) return;
  tabsEl.dataset.cockpit = "1";
  const alle = Array.from(tabsEl.querySelectorAll<HTMLButtonElement>(":scope > .tab-btn"));
  const bereichVon = (tab: string): string => BEREICHE.find((b) => b.tabs.includes(tab))?.key ?? FALLBACK;

  // Reiter in Bereichs-Reihenfolge bringen (innerhalb eines Bereichs wie oben festgelegt, Unbekannte hinten)
  const rang = (tab: string): number => { const b = BEREICHE.findIndex((x) => x.tabs.includes(tab)); return b < 0 ? 999 : b * 100 + BEREICHE[b]!.tabs.indexOf(tab); };
  alle.sort((a, b) => rang(a.dataset.tab ?? "") - rang(b.dataset.tab ?? "")).forEach((btn) => {
    btn.dataset.bereich = bereichVon(btn.dataset.tab ?? "");
    tabsEl.appendChild(btn);
  });

  const zeile = document.createElement("div");
  zeile.className = "cockpit-bereiche";
  const bereichKnoepfe = new Map<string, HTMLButtonElement>();
  for (const b of BEREICHE) {
    const k = document.createElement("button");
    k.type = "button";
    k.className = "cockpit-bereich";
    k.dataset.bereich = b.key;
    k.textContent = b.label;
    const z = document.createElement("span");
    z.className = "tab-badge"; z.hidden = true;
    k.appendChild(z);
    zeile.appendChild(k);
    bereichKnoepfe.set(b.key, k);
  }
  tabsEl.before(zeile);

  const zeigeBereich = (key: string, tab?: string): void => {
    for (const [k, knopf] of bereichKnoepfe) knopf.classList.toggle("active", k === key);
    const eigene = alle.filter((btn) => btn.dataset.bereich === key);
    for (const btn of alle) btn.hidden = btn.dataset.bereich !== key;
    // Reiter wählen: ausdrücklich gewünscht → zuletzt benutzter dieses Bereichs → erster
    const ziel = eigene.find((btn) => btn.dataset.tab === tab)
      ?? eigene.find((btn) => btn.dataset.tab === lies(`cockpit.tab.${key}`))
      ?? eigene[0];
    if (ziel && !ziel.classList.contains("active")) ziel.click();
    merke("cockpit.bereich", key);
  };

  for (const [key, knopf] of bereichKnoepfe) knopf.addEventListener("click", () => zeigeBereich(key));
  for (const btn of alle) btn.addEventListener("click", () => {
    const b = btn.dataset.bereich ?? FALLBACK;
    merke(`cockpit.tab.${b}`, btn.dataset.tab ?? "");
  });

  // Zähler der Reiter (Inbox, Social, Google Ads …) summiert auch am Bereich zeigen
  const summiere = (): void => {
    for (const [key, knopf] of bereichKnoepfe) {
      const n = alle.filter((btn) => btn.dataset.bereich === key)
        .reduce((s, btn) => { const t = btn.querySelector(".tab-badge") as HTMLElement | null; return s + (t && !t.hidden ? Number(t.textContent) || 0 : 0); }, 0);
      const z = knopf.querySelector(".tab-badge") as HTMLElement;
      z.textContent = String(n); z.hidden = n === 0;
    }
  };
  new MutationObserver(summiere).observe(tabsEl, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ["hidden"] });
  summiere();

  const gemerkt = lies("cockpit.bereich");
  zeigeBereich(BEREICHE.some((b) => b.key === gemerkt) ? gemerkt! : "planung");
}
